<div>
  @if (busy) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  @if (barChartData) {
    <canvas height="300" baseChart [data]="barChartData" [options]="barChartOptions" [plugins]="barChartPlugins" [type]="barChartType">
    </canvas>
  }
</div>